import { Filters, Queries } from "../types/filters";

export const getQueryParamsObj = (config: string, filters: Filters) => {

  const queries: Queries = {};

  const {
    category,
    in_stock,
    distance,
    dealer,
    model,
    year,
    price,
    mileage,
    trimline,
    transmission,
    color_exterior,
    color_interior,
    // vehicle_type,
    sort_price,
    sort_added,
    sort_mileage,
    limit,
    page
  } = filters;

  if (distance) {
    queries.distance = String(distance);
  }

  if (category?.length && !(category?.length === 2 && category?.includes("new") && category?.includes("used"))) {
    queries.category = category.join();
  }

  if (in_stock) {
    queries.in_stock = String(in_stock);
  }

  if (dealer?.length) {
    queries.dealer = dealer.join();
  }

  if (model?.length && config !== "filters") {
    queries.model = model.join();
  }

  // if (vehicle_type?.length) {
  //   queries.vehicle_type = vehicle_type.join();
  // }

  if (year?.length) {
    queries.year = year.join(":");
  }

  if (price) {
    queries.price = config === "url" ? String(price) : `0:${price}`;
  }

  if (mileage) {
    queries.mileage = config === "url" ? String(mileage) : `0:${mileage}`;
  }

  if (trimline?.length) {
    queries.trimline = trimline.join();
  }

  if (transmission?.length) {
    queries.transmission = transmission.join();
  }

  if (color_exterior?.length) {
    queries.color_exterior = color_exterior.join();
  }

  if (color_interior?.length) {
    queries.color_interior = color_interior.join();
  }

  if (sort_price) {
    queries.sort_price = sort_price;
  }

  if (sort_added) {
    queries.sort_added = sort_added;
  }

  if (sort_mileage) {
    queries.sort_mileage = sort_mileage;
  }

  if (limit && config === "vehicles") {
    queries.limit = String(limit);
  }

  if (page && config === "vehicles") {
    queries.page = String(page);
  }

  return queries;
};

const isSearchingAllInventoryType = (selection?: string[]) => {
  return (selection?.length && !(selection?.length === 2 && selection?.includes("new") && selection?.includes("used")));
}

export const getQueryParamsV2 = (filters: Filters) => {

  const queries: Queries = {};

  const keys = Object.keys(filters) as (keyof Filters)[];

  keys.forEach((key) => {
    if (!String(filters[key])?.length) {
      // console.log(key, String(filters[key])?.length);
      return;
    }

    switch (key) {
      case "category":
        if (isSearchingAllInventoryType(filters[key])) {
          queries[key] = filters[key]?.join();
        }
        break;
      case "price":
      case "mileage":
        queries[key] = `0:${filters[key]}`;
        break;
      case "year":
        queries[key] = filters[key]?.join(":");
        break;
      case "dealer":
      case "model":
      case "trimline":
      case "transmission":
      case "color_exterior":
      case "color_interior":
        if (filters[key]) {
          queries[key] = filters[key]?.join();
        }
        break;
      default:
        queries[key as keyof Queries] = String(filters[key]);
    }

    return;
  });

  return queries;
};
